export default __webpack_public_path__ + "static/media/s2.cc06364d.jpg";